import { render, staticRenderFns } from "./OrganizationDashboardInsights.vue?vue&type=template&id=00d7cd2e&scoped=true&"
import script from "./OrganizationDashboardInsights.vue?vue&type=script&lang=js&"
export * from "./OrganizationDashboardInsights.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationDashboardInsights.vue?vue&type=style&index=0&id=00d7cd2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d7cd2e",
  null
  
)

export default component.exports